import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SystemReportDataType } from "../types/SystemReportDataType";

export const useGetSystemReportData = (companyId: number | undefined, reportCode: string | undefined, dateFrom: Date | undefined, dateTo: Date | undefined, year: number | undefined, useYear: boolean) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['get-system-report-data', companyId, reportCode, dateFrom, dateTo, year],
        queryFn: async () => await apiClient.get('system-reports/data', {
            params: {
                reportCode,
                dateFrom,
                dateTo,
                year,
                useYear
            }
        }) as SystemReportDataType,
        enabled: false
    });

    return {
        data,
        isLoading,
        refetch
    };
};
